import React from 'react'
import { motion } from 'framer-motion'
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js'
import { format } from 'date-fns'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const LiquidationResult = ({ result }) => {
  if (!result) return null

  const data = result;
  const formattedDate = format(new Date(data.timestamp), 'PPpp')

  const chartData = {
    labels: ['Entry Price', 'Liquidation Price'],
    datasets: [
      {
        label: 'Price ($)',
        data: [data.entry_price, data.liquidation_price],
        backgroundColor: ['#22c55e', '#ef4444'],
        borderRadius: 10,
        barThickness: 28
      }
    ]
  }

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: ctx => `$${ctx.raw.toFixed(2)}`
        }
      }
    },
    scales: {
      y: {
        ticks: {
          callback: val => `$${val}`,
          color: '#fff'
        },
        grid: { color: 'rgba(255,255,255,0.1)' }
      },
      x: {
        ticks: { color: '#fff' },
        grid: { display: false }
      }
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="rounded-2xl p-6 shadow-xl bg-slate-800/50 text-white backdrop-blur-lg border border-white/10"
    >
      <h2 className="text-2xl font-bold mb-4">Liquidation Result</h2>
      <p className="text-sm text-gray-300 mb-6">Data reflects the most recent update as of: {formattedDate}</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <InfoBlock label="Exchange" value={data.exchange} />
        <InfoBlock label="Symbol" value={data.symbol} />
        <InfoBlock label="Leverage" value={`${data.leverage}x`} />
        <InfoBlock label="Side" value={
          <span className={`px-2 py-1 rounded text-xs ${data.side === 'long' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
            {data.side.toUpperCase()}
          </span>
        } />
        <InfoBlock label="Margin Type" value={data.margin_type} />
        <InfoBlock label="Maint. Margin Rate" value={`${(data.maintenance_margin_rate * 100).toFixed(2)}%`} />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mb-8">
        <InfoBlock label="Entry Price" value={`$${data.entry_price.toFixed(2)}`} />
        <InfoBlock label="Liquidation Price" value={`$${data.liquidation_price.toFixed(2)}`} />
      </div>

      <div>
        <h3 className="text-lg font-semibold mb-2">Price Comparison</h3>
        <Bar data={chartData} options={chartOptions} />
      </div>

      <p className="text-xs text-gray-300 mt-6">This is tentative data and may not reflect precise values.</p>
    </motion.div>
  )
}

const InfoBlock = ({ label, value }) => (
  <div>
    <p className="text-sm text-gray-400">{label}</p>
    <p className="font-semibold">{value}</p>
  </div>
)

export default LiquidationResult
